import { withDependencies } from '@wix/thunderbolt-ioc'
import type { SdkHandlersProvider } from '@wix/thunderbolt-symbols'
import type { SiteWixCodeSdkEditorHandlers } from '../types'
import {
	IViewerManagerPlatformApplicationRequestsAPI,
	ViewerManagerPlatformApplicationRequestsAPISymbol,
} from 'ds-feature-viewer-manager-platform-api'

export const siteSdkEditorProvider = withDependencies(
	[ViewerManagerPlatformApplicationRequestsAPISymbol],
	(
		viewerManagerPlatformNotifyAppReqCBApi: IViewerManagerPlatformApplicationRequestsAPI
	): SdkHandlersProvider<SiteWixCodeSdkEditorHandlers> => ({
		getSdkHandlers: () => ({
			notifyEventToEditorApp: (appDefinitionId, eventData) => {
				viewerManagerPlatformNotifyAppReqCBApi.triggerCallbacks(appDefinitionId, eventData)
			},
		}),
	})
)
